<template>
	<div class="featured-collection-slider">
		<div class="swiper-container" ref="collectionSwiper">
			<div class="swiper-wrapper">
				<div
					class="swiper-slide"
					v-for="(product, index) in data"
					:key="index"
					data-aos="fade-up"
					data-aos-duration="400"
					:data-aos-delay="calcDelay(index)"
				>
					<product-card :url="url" :item="product"></product-card>
				</div>
			</div>
		</div>
		<div class="swiper-button-prev" ref="prev"></div>
		<div class="swiper-button-next" ref="next"></div>
		<div class="swiper-pagination"></div>
	</div>
</template>

<script>
import Swiper from "swiper/dist/js/swiper.js";
import productCard from "./product-card.vue";

export default {
	components: { productCard },
	props: {
		items: { type: Array, required: true },
		url: {type: String, required: false }
	},
	computed: {
		data: t => t.items.map(x => JSON.parse(x))
	},
	methods: {
		calcDelay(i) {
			return 100 * i;
		}
	},
	mounted() {
		// init swiper
		const swiperOptions = {
			slidesPerView: 4,
			slidesPerGroup: 4,
			loop: false,
			watchOverflow: true,
			loopFillGroupWithBlank: true,
			keyboardControl: true,
			pagination: {
				el: ".swiper-pagination",
				clickable: true,
				renderBullet: function(index, className) {
					return (
						'<span class="' +
						className +
						'">' +
						(index + 1) +
						"</span>"
					);
				}
			},
			navigation: {
				nextEl: this.$refs.next,
				prevEl: this.$refs.prev
			},
			breakpoints: {
				// when window width is <= 320px
				1024: {
					slidesPerView: 3,
					slidesPerGroup: 3
				},
				768: {
					slidesPerView: 2,
					slidesPerGroup: 2
				}
			}
		};
		const collectionSwiper = new Swiper(
			this.$refs.collectionSwiper,
			swiperOptions
		);
	}
};
</script>

<style lang="scss" scoped>
.swiper-container {
	width: 100%;
	background-color: inherit;

	&::v-deep .product-card:hover {
		background-color: #eeeeee;
	}
}
.swiper-pagination {
	position: relative;
	width: 100%;
	text-align: right;
	text-align: -webkit-right;
	margin-top: 40px;
	z-index: 5;

	@include res(tab-p) {
		margin: 0;
	}

	&::v-deep span {
		background-color: transparent;
		opacity: 1;
		border-radius: 0;
		color: $medium-grey;
		font-size: 10px;
		width: 25px;
		height: 25px;
		display: inline-flex;
		justify-content: center;
		align-items: center;

		&:focus {
			outline: none;
			background-color: $medium-grey;
		}
		
		&.swiper-pagination-bullet-active {
			background-color: $medium-grey;
			color: $white;
		}
	}
}
</style>